const firebaseConfig = {
  apiKey: "AIzaSyCXvrzlP5EaBj8RrhX5nKLHQDun76SDIIk",
  authDomain: "emma-john-simple-1b676.firebaseapp.com",
  projectId: "emma-john-simple-1b676",
  storageBucket: "emma-john-simple-1b676.appspot.com",
  messagingSenderId: "771737399997",
  appId: "1:771737399997:web:b3ac0ba42dbf791443fdd4",
};
export default firebaseConfig